import { Box, Grid, Skeleton } from "@mui/material";
import FormSkeleton from "./form";

const steps = [1, 2, 3];

const SkeletonStepper = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        {steps.map((_, i) => (
          <Box key={i} sx={{ display: "flex" }}>
            <Box
              sx={{
                pr: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  width: 24,
                  height: 24,
                }}
              >
                <Skeleton variant="circular" width={24} height={24} />
              </Box>
              {i !== steps.length - 1 && (
                <Box
                  sx={{
                    height: "90%",
                    borderLeft: "1px solid",
                    borderColor: "grey.400",
                    minHeight: 24,
                    my: 1,
                  }}
                />
              )}
            </Box>

            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="60%" height={24} />

              <Box sx={{ pt: 2 }}>
                {i == 0 && (
                  <>
                    <FormSkeleton />
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mt: 2,
                      }}
                    >
                      <Skeleton
                        variant="rectangular"
                        width={80}
                        height={32}
                        sx={{ mr: 1 }}
                      />
                      <Skeleton variant="rectangular" width={140} height={32} />
                    </Box>
                  </>
                )}
              </Box>
            </Box>
          </Box>
        ))}
      </Grid>
    </Grid>
  );
};

export default SkeletonStepper;
